module.exports = __webpack_public_path__ + "img/Popup_Akteure3.9a40c427.png";